<template>

  <div id="bg">
  <div id="wrapper">

    <!-- Nav and Login Button -->
    <LandingHeader />

    <h1>You've got questions,<br/>we've got answers.</h1>

    <div class="faq-container">

      <div class="item">
        <h3>Is this an official Whatsapp product?</h3>
        <p>Nope, but we are in the official Facebook accelerator, which is why we're the only survey bot available on Whatsapp.</p>
      </div>

      <div class="item">
        <h3>Do you provide a panel?</h3>
        <p>Not at the moment. When you create a survey you get a unique link that you can distribute to your own audience or customers however you’d like.</p>
      </div>

      <div class="item">
        <h3>What is your pricing model?</h3>
        <p>We break down our pricing by each individual answer so you pay for exactly what you get, not a penny more. Our pricing is based on answers types (video, audio, image, multi-choice, text).</p>
      </div>

      <div class="item">
        <h3>What happens if I exceed my wallet balance?</h3>
        <p>Don’t worry, we won’t charge you automatically. Instead, your respondents will simply see a message that the survey is full.</p>
      </div>

      <div class="item">
        <h3>How do you handle data privacy?</h3>
        <p>We ensure that only you have access to any responses for your surveys. Whatsapp and it’s end-to-end encryption takes care of the rest.</p>
      </div>

      <div class="item">
        <h3>Can I export my data to use in another app?</h3>
        <p>Yes you can. You can export all your responses in either CSV or JSON, and we’re working on more integrations (including an API and Zapier) to let you have full control over your data.</p>
      </div>

      <div class="item">
        <h3>Can I use Facebook Messenger instead?</h3>
        <p>Actually, yes. Your survey can work on both Whatsapp and Facebook Messenger, if you’re interested in this, ping us and we’ll show you what to do.</p>
      </div>

      <div class="item">
        <h3>Do you have an iOS or Android app?</h3>
        <p>Our surveys work entirely in Whatsapp, so the short answer is no. You can access your survey results through our Responsive Web App on either desktop or mobile web.</p>
      </div>

    </div>

  </div>


  <!-- Landing Footer -->
  <LandingFooter />

  </div>


</template>

<script>

import LandingHeader from '@/components/landing/LandingHeader.vue';
import LandingFooter from '@/components/landing/LandingFooter.vue';
export default {

  name: 'pricing',

  components: {
    LandingHeader,
    LandingFooter
  },

  data: function () {
    return {}
  },

  computed: {},

  methods: {},

  created() {

    analytics.page('FAQ');

  }

}
</script>


<style lang="scss" scoped>

#bg{
  display: block;
  width: 100%;
  min-height: 100%;
  height: auto;
  background-image:
    url("../assets/landing-world-bg.png"),
    url("../assets/landing-whatsapp-bg.png");
  background-position:
    center,
    top left;
  background-repeat:
    no-repeat,
    repeat;
  overflow: hidden;
}

#wrapper{
  display: block;
  width: 1050px;
  height: 100%;
  margin: 0 auto;
  padding-top: 180px;
  position: relative;
  font-family: 'Montserrat', sans-serif;
}

h1{
  color: #13D298;
  font-size: 30px;
  font-weight: 600;
}

.faq-container{
  width: 100%;
  padding: 50px 40px;
  margin-top: 50px;
  background-color: #0A212D;
  border-radius: 6px;
}

.item{
  width: 42%;
  opacity: 1;
  display: inline-block;
  vertical-align: top;
  margin-bottom: 35px;
  margin-right: 50px;
  h3, p{
    color: white;
  }
  h3{
    font-size: 19px;
    line-height: 29px;
    font-weight: 600;
  }
  p{
    font-size: 15px;
    line-height: 25px;
    font-weight: 400;
  }
}


#copyright{
  display: block;
  margin: 0 auto;
  width: 170px;
  margin-top: 100px;
  margin-bottom: 30px;
  opacity: .8;
}



// Mobile Styles
@media only screen
and (min-device-width: 320px)
and (max-device-width: 480px) {

#wrapper{
  width: 88%;
  padding-top: 40px;
}

h1{
  font-size: 25px;
  margin-top: 80px;
  margin-left: 15px;
}

.faq-container{
  padding: 35px 30px;
  margin-top: 40px;
  margin-bottom: 30px;
}

.item{
  width: 100%;
  h3{
    font-size: 19px;
    line-height: 29px;
  }
  p{
    font-size: 15px;
    line-height: 25px;
  }
}

#copyright{
  margin-top: 10px;
  margin-bottom: 30px;
}

}

</style>
